export const SET_IS_LOADING = 'setIsLoading';
export const setIsLoading = (loadingState) => ({
    type: SET_IS_LOADING,
    payload: loadingState,
});

export const OPEN_CLOSE_FILTER_PANEL_MOBILE = 'OPEN_CLOSE_FILTER_PANEL_MOBILE';
export const openCloseFilterPanelMobile = (open, filterType) => ({
    type: OPEN_CLOSE_FILTER_PANEL_MOBILE,
    payload: {open, filterType},
});
